import { UpdatePageLayout } from 'framework/ui/layout';
import { useFormContext } from 'framework/form';
import CandidateDuplicateScanForm from './CandidateDuplicateScanForm';
import { ErrorBoundaryContainer } from 'framework/ui/ErrorBoundary';
import { BLOCKED_STATUS_TEXT_MAP } from '../constants';
import { Box } from '@mui/material';

interface CandidateDuplicateScanProcessLayoutProps {
  onCancelAction: () => void;
}

const CandidateDuplicateScanProcessLayout = ({ onCancelAction }: CandidateDuplicateScanProcessLayoutProps) => {
  const { data } = useFormContext();
  const blockedStatus = data?.scanReadBlockedStatus;

  if (blockedStatus) {
    return (
      <Box sx={{ '& .MuiTypography-h4': { pt: 3.5 } }}>
        <ErrorBoundaryContainer
          title={BLOCKED_STATUS_TEXT_MAP[blockedStatus].title}
          description={BLOCKED_STATUS_TEXT_MAP[blockedStatus].description ?? ''}
          errorDescription=""
        />
      </Box>
    );
  }

  return (
    <UpdatePageLayout onCancelAction={onCancelAction} title="Duplicate Scan Process">
      <CandidateDuplicateScanForm />
    </UpdatePageLayout>
  );
};

export default CandidateDuplicateScanProcessLayout;
